AgrimarketServices.service("grainbowService", [
    '$rootScope', '$http', '$location', 'configurationFactory',
    function($rootScope, $http, $location, configurationFactory) {

        var sendRequest = function(configfile, callback) {
            $http(configfile)
                .success(function(data) {
                    callback(data, null, null, null);
                })
                .error(function(data, status, headers, config) {
                    callback(data, status, headers, config);
                });
        };

        this.GetGrainbowEntraIDConfig = function (callback) {
            var config = {
                method: "GET",
                url: configurationFactory.Url['Api'] + "Grainbow/GetGrainbowEntraIDConfig"
            };
            sendRequest(config, callback);
        };

        this.ValidateGrainbowToken = function (token, callback) {
            var config = {
                method: "POST",
                url: configurationFactory.Url['Api'] + "Grainbow/ValidateToken",
                data: { grainbowToken: token }
            };
            sendRequest(config, callback);
        };

        this.LogGrainbowByEntraID = function (code, redirectUri, callback) {
            var config = {
                method: "POST",
                url: configurationFactory.Url['Api'] + "Grainbow/LogGrainbow",
                data: { code: code, redirectUri: redirectUri }
            };
            sendRequest(config, callback);
        };

    }
]);
